module.exports = __webpack_public_path__ + "img/dinner.b07f6984.png";